module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/banner/en-56f1bcc5ee81822cdfa03db52e83284e.jpg";